import { render, staticRenderFns } from "./ConclusionList.vue?vue&type=template&id=07fca14a&scoped=true&"
import script from "./ConclusionList.vue?vue&type=script&lang=js&"
export * from "./ConclusionList.vue?vue&type=script&lang=js&"
import style0 from "./ConclusionList.vue?vue&type=style&index=0&id=07fca14a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fca14a",
  null
  
)

export default component.exports